import { PassedInitialConfig } from 'angular-auth-oidc-client';
import { environment } from '../../../environments/environment';

export const authConfig: PassedInitialConfig = {
  config: {
    authority: environment.oidcConfig.authority,
    redirectUrl: window.location.origin + '/auth/callback',
    postLogoutRedirectUri: window.location.origin,
    clientId: environment.oidcConfig.clientId,
    scope: environment.oidcConfig.scope,
    responseType: 'code',
    silentRenew: true,
    useRefreshToken: true,
    renewTimeBeforeTokenExpiresInSeconds: 300,
    maxIdTokenIatOffsetAllowedInSeconds: 300,
    logLevel: environment.oidcConfig.logLevel
  }
}
